<template>
  <div id="publish-template-modal" class="editor-modal">
		<div class="create"> 
			<h2>{{$t('template.pub-tp-title')}}</h2>
			<form @submit="onPublish" >
				<custom-input v-if="!lockNewPublications" :inputType="'text'" v-model="publicationName" :name="'nameInput'" :label="$t('template.pub-tp-name-label')" :placeholder="$t('template.pub-tp-name-placeholder')" @input="existingPublication = null"/>
				<p v-else>{{$t('template.pub-tp-limit-msg')}}</p>

				<div v-if="publications && publications.length">
				<p class="option-divider" v-if="!lockNewPublications">{{$t('template.pub-tp-or')}}</p>
					<div class="form-group">
						<label for="existing" :class="{'hide-label': !existingPublication}">{{$t('template.pub-tp-existing')}}</label>
						<select :class="{ empty: !this.existingPublication }" @change="publicationName = ''" class="form-control selector" id="existingInput" v-model="existingPublication">
							<option class="default" :value="null">{{$t('template.pub-tp-existing')}}</option>
							<option v-for="publication in publications" :key="publication.id" :value="publication" v-html="publication.name" />
						</select>
					</div>
				</div>

				<span v-if="wrongSource" class="text-danger">{{$t("template.publish-error1")}}</span>
				<span v-if="someError" class="text-danger">{{$t("template.publish-error2")}}<a style="color:#dc3545; text-decoration:underline;" href="mailto:contact@icrobotics.com">contact@icrobotics.com </a> {{$t("template.publish-error3")}}</span>

				<div class="footer">
					<button type="submit" class="btn btn-md btn-primary" :disabled="working || !valid" @click="onPublish" >{{$t('template.pub-tp-btn-publish')}}</button>
					<button  type="reset" class="btn btn-md btn-secondary" :disabled="working" @click="$emit('close')">{{$t('template.pub-tp-btn-cancel')}}</button>
				</div>
			</form>
		</div>		
	</div>
</template>

<script>
import CustomInput from "@/components/CustomInput";
export default {
    props: {
        template: Object,
		publications: Array,
		onSave: Function
		},
		data () {
			return {
				publicationName: '',
				existingPublication: null,
				working: false,
				isHidden: false,
				wrongSource: false,
				someError: false
			}
		},
		computed: {
			valid () {
				return this.existingPublication || this.publicationName && this.publicationName.trim()
			},
			publicationCount(){
				// return this.$store.state.templates.filter(t => t.published).length
				return this.publications.length
			},
			publicationLimit(){
				return 100
			},
			lockNewPublications(){
				return this.publicationCount >= this.publicationLimit
			}
		},
		methods: {
	
			onPublish (evt) {
			evt.preventDefault();
				this.working = true
				this.wrongSource = false
				this.someError = false
				this.$store.dispatch('publishTemplate', { publicationName: this.publicationName, template: this.template, existingPublication: this.existingPublication }).then(() => {
					this.working = false	
				})
				.catch(e =>{
					if(e.status === 400){
						console.log(e)
						this.wrongSource = true
						this.working = false
					}
					else{
						console.log(e)
						this.someError = true
						this.working = false
					}
				})
					this.$emit('close')
					this.onSave()
},
				close () {
					this.$emit('close')
					this.wrongSource = false
					this.someError = false
				}
		},
			components:{CustomInput}

}
</script>

<style lang="less">
#publish-template-modal {
	padding: 30px 25px 25px 25px;
	h2 {
		margin: 0;
	}
			
	.footer {
		margin-top: 40px
	}

	.option-divider{
		font-weight: 600;
		margin:0;
		margin-top: 20px;
	}
	.hide-label{
		opacity: 0;
	}
}
</style>